// extracted by mini-css-extract-plugin
export default {"modCont":"ModalWindow_modCont__I+TrQ","darkBG_":"ModalWindow_darkBG___97Hxo","darkBG":"ModalWindow_darkBG__Lq7gg","centered":"ModalWindow_centered__mGObv"};